module.exports = __webpack_public_path__ + "ef22cf65131768100a8d3be50a65def9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-10.svg
// module id = 549
// module chunks = 0